import "./UserHeader.css";

import { useState } from "react";

import { ArrowFullLeftDarkIcon, HelpCircleDarkIcon } from "../../../assets";
import { Avatar, Button, Divider, HelpCenter } from "../..";
import { ProfileMenu } from "../ProfileMenu";
import { ProfileMenuItem } from "../ProfileMenuItem";
import { useUserHeader } from "./useUserHeader";

interface UserHeaderProps {
  backButtonText?: string;
  handleBackClick?: () => void;
}

export const UserHeader = ({ backButtonText, handleBackClick }: UserHeaderProps): JSX.Element => {
  const [showHelpCenter, setShowHelpCenter] = useState(false);
  const { showProfileMenu, setShowProfileMenu, currentUserData, optionList, onOptionSelect } = useUserHeader();

  return currentUserData ? (
    <>
      <header className="UserHeader">
        {backButtonText ? (
          <Button
            variant="secondary"
            text={backButtonText}
            icon={<ArrowFullLeftDarkIcon />}
            iconPosition="left"
            onClick={handleBackClick}
          />
        ) : (
          <div />
        )}
        {/* TODO: Change this when we implement notifications component */}
        <Button
          className={`UserHeaderHelpButton ${showHelpCenter && "UserHeaderHelpButton_active"}`}
          onClick={() => setShowHelpCenter((prev) => !prev)}
          text=""
          icon={<HelpCircleDarkIcon />}
          hasNoPadding
          minWidth={false}
          variant="quinary"
          size="small"
        />
        <div>
          <Avatar
            imageSource={currentUserData?.avatar?.url}
            name={`${currentUserData?.firstName} ${currentUserData?.lastName}`}
            withName
            onClick={() => setShowProfileMenu(true)}
          />
          <ProfileMenu show={showProfileMenu} onClose={() => setShowProfileMenu(false)}>
            {optionList.map((option, index) => (
              <div key={option.id} className="ProfileMenuItemWrapper">
                <ProfileMenuItem profileMenuItem={option} onClick={() => onOptionSelect(option)} />
                {(index === 1 || index === 2) && <Divider className="ProfileMenuItemDivider" type="horizontal" />}
              </div>
            ))}
          </ProfileMenu>
        </div>
      </header>
      <HelpCenter show={showHelpCenter} onClose={() => setShowHelpCenter(false)} variant="hub" />
    </>
  ) : (
    <div />
  );
};
